'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:invoke:ready');
}

var env = require('./env.js');

var fnQueue = [];

document.addEventListener('HBNB:ready', function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('fnQueue length = %s', fnQueue.length);
    }

    for (var i = 0, ii = fnQueue.length; i < ii; ++i) {
        fnQueue[i]();
    }
});

var ready = function(fn) {
    if (typeof fn !== 'function') {
        return;
    }

    if (env.HBNBReady) {
        fn();
    } else {
        if (process.env.NODE_ENV !== 'production') {
            debug('push fn to fnQueue');
        }

        fnQueue.push(fn);
    }
};

module.exports = ready;



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/invoke/ready.js
// module id = 219
// module chunks = 10 11 12 13 14 15 16 17 18 19